import { render, staticRenderFns } from "./commodityList_new.vue?vue&type=template&id=76ad976c&scoped=true&"
import script from "./commodityList_new.vue?vue&type=script&lang=js&"
export * from "./commodityList_new.vue?vue&type=script&lang=js&"
import style0 from "./commodityList_new.vue?vue&type=style&index=0&id=76ad976c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ad976c",
  null
  
)

export default component.exports